import { Box, Button, Grid, Typography } from '@mui/material';
import { useFieldManagement } from 'Features/fieldManagement/useFieldManagement';
import { t } from 'i18next';
import { FormProvider } from 'react-hook-form';
import FieldDropdownGroup from './FieldDropdownGroup';
import './FieldManagement.scss';

const FieldManagement = () => {
  const { methods, dropdownConfigs, handleAction, handleShuffle } = useFieldManagement();

  const handleCancel = () => {
    console.log('Handle Cancel');
  };

  const onSubmit = (data) => {
    console.log('handle submit', data);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Box className="field-management-main">
          <Grid container spacing={2} className="field-management-header">
            <Grid item>
              <Typography variant="h6" className="field-management-title">
                {t('fieldManagement.title')}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <FieldDropdownGroup
              configList={dropdownConfigs}
              onAction={handleAction}
              onShuffle={handleShuffle}
            />
          </Grid>

          <Box sx={{ display: 'none' }}>
            <Grid item xs={12} sm={8}>
              <Button variant="outlined" color="primary" onClick={handleCancel} sx={{ mt: 2 }}>
                {t('button.cancel')}
              </Button>
              <Button type="submit" variant="contained" color="primary" sx={{ mt: 2, ml: 2 }}>
                {t('button.save')}
              </Button>
            </Grid>
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
};

export default FieldManagement;
